/**
 * Pomocná funkce pro převod string na int.
 * Rozšíření typu argumentu o undefined.
 *
 * @param value
 */
export const safeParseInt = (value: string | undefined) => {
    if (!value) {
        return undefined;
    }
    return parseInt(value);
};
